import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import { StrictMode } from 'react';

import ReactDOM from 'react-dom';

import { loadAppConfig } from './config/appConfig';
import './index.css';
import ThemeProvider from './themes/ThemeProvider';

const initApp = async () => {
    await loadAppConfig();

    const { App } = await import('./App');

    const container = document.getElementById('root');

    ReactDOM.render(
        <StrictMode>
            <ThemeProvider>
                <App />
            </ThemeProvider>
        </StrictMode>,
        container
    );
};

initApp();
